import type { Project } from '@/types';

// Пустой список - пользователь может добавить свои проекты
export const projects: Project[] = [];
